import * as React from "react";
import { isMobileHost } from "../utils/mobileHost";

// Below Tailwind's `lg` breakpoint covers phones and tablets.
const TABLET_BREAKPOINT = 1024;

/**
 * True on phone/tablet-sized viewports (and always on the m.idarah.io mobile
 * host). Used to offer PIN login only where typing a full password is
 * inconvenient — desktop sessions always get the password form.
 */
export function useMobileOrTablet() {
  const [isMobileOrTablet, setIsMobileOrTablet] = React.useState<boolean>(
    () => typeof window !== "undefined" && window.innerWidth < TABLET_BREAKPOINT,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${TABLET_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobileOrTablet(window.innerWidth < TABLET_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    onChange();
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobileOrTablet || isMobileHost();
}
